export default (state) => id => {
    if (!state.permit.items) return false;
    return !!state.permit.items.filter(i => {
        return i.Type === id;
    })[0];
}